<app-dialog-header title="Ajouter des fichiers" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle />
<div mat-dialog-content style="padding: 8px;">

  <div class="section-admin-subtitle">
    <app-icon type="mat" icon="arrow_right" color="primary"></app-icon>
    Sélectionner les fichiers :
  </div>

  <div style="margin: auto; display: flex; flex-direction: column;">
    <div class="container" appDragAndDropFile (fileDropped)="!loading && onFileDropped($event)">
      <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event)" [disabled]="loading" />
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
      <h3>Faites glisser et déposez les fichiers ici</h3>
      <button mat-raised-button color="accent-lighter" (click)="fileDropRef.click()" type="button" [disabled]="loading">
        <mat-icon>upload_file</mat-icon>
        Choisir des fichiers
      </button>
    </div>

    <div class="files-list thin-scrollbar" *ngIf="files.length > 0">
      <div class="single-file" *ngFor="let file of files; let i = index">
        <app-icon size="30" *ngIf="getIcon(file.type) as icon; else default" type="far" [icon]="'file-'+icon"
          [class.invalid]="!valid"></app-icon>
        <ng-template #default><i class="far fa-file "></i></ng-template>
        <div class="info">
          <h4 class="name">
            {{ file?.name }}
          </h4>
          <p class="size">
            {{ formatBytes(file?.size) }}
          </p>
          <mat-progress-bar *ngIf="file.status === 'uploading'" mode="determinate" [value]="file?.progress"
            color="accent">
          </mat-progress-bar>
        </div>
        <mat-icon *ngIf="file.status === 'success'" class="status-success">check_circle</mat-icon>
        <mat-icon *ngIf="file.status === 'error'" class="status-error">error</mat-icon>
        <button mat-icon-button *ngIf="file.status === 'error'" (click)="retryFile(file)" color="primary"
          matTooltip="Réessayer" class="cancel-selected-button">
          <mat-icon>refresh</mat-icon>
        </button>
        <button mat-icon-button *ngIf="!file.status" (click)="deleteFile(i)" color="warn"
          matTooltip="Supprimer" class="cancel-selected-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>

</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" type="button">Annuler</button>
  <button mat-raised-button color="primary" [disabled]="files.length === 0 || loading" (click)="add()"
    matTooltip="Envoyer les fichiers">
    <mat-icon>cloud_upload</mat-icon>
    Envoyer
  </button>
</div>